<form #form="ngForm">
    <p *ngIf="additions.length === 0">{{ 'time-off-v3.noEmployeeAdditions' | translate }}</p>
    <ng-container *ngIf="additions.length > 0">
        <p>{{ 'time-off-v3.youveSelectedAdditionsNewEmployeesToAdd' | translate: { length: additions.length } }}</p>

        <div class="app-grid">
            <mat-form-field class="columns-3" *ngIf="!timeOffPolicy.isUnlimited">
                <mat-label appRemoveAriaOwns>{{ 'time-off-v3.accrualStartDate' | translate }}</mat-label>
                <mat-select
                    name="accrualStartDate"
                    placeholder="{{ 'time-off-v3.selectAccrualStartDate' | translate }}"
                    [ngModel]="accrualStartDate"
                    (ngModelChange)="accrualStartDate = $event"
                    required
                >
                    <mat-option value="Date Hired">{{ 'time-off-v3.dateHired' | translate }} </mat-option>
                    <mat-option value="Select a date">{{ 'time-off-v3.selectADate' | translate }} </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="accrualStartDate === 'Select a date'" class="columns-3">
                <input
                    [ngModel]="userSelectedDate"
                    (ngModelChange)="userSelectedDate = $event"
                    [matDatepicker]="accrualStartDatePicker"
                    name="accrualDatePickerInput"
                    #accrualDatePickerInput="ngModel"
                    matInput
                    required
                />
                <mat-datepicker-toggle matSuffix [for]="accrualStartDatePicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #accrualStartDatePicker></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="app-grid title-wrapper">
            <h4 class="columns-4">{{ 'time-off-v3.newlyAddedEmployees' | translate }}</h4>
        </div>

        <ng-container *ngFor="let employee of additions; let i = index">
            <div class="app-grid item-wrapper">
                <app-avatar class="columns-4" [employee]="employee" [name]="true"></app-avatar>
            </div>
        </ng-container>
    </ng-container>
</form>
